import { render, staticRenderFns } from "./Internal-Quotation-Detail.vue?vue&type=template&id=98950ac2"
import script from "./Internal-Quotation-Detail.vue?vue&type=script&lang=js"
export * from "./Internal-Quotation-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports